import styled from "styled-components";
import { List } from "../../../shared/ui/list/listComponents";

export const StyledList = styled(List)`
	margin-top: auto;
`;
